import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import TableContainer from "@mui/material/TableContainer";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TableHead from "@mui/material/TableHead";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";
import { post } from "../../../common/network";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

const AssignAttorney = ({
    openModal,
    closeModal,
    selectedDockets = [],
    setSelectedDockets,
}) => {
    const [attorneys, setAttorneys] = useState([]);
    const [assignedDockets, setAssignedDockets] = useState([]);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        if (openModal) {
            setAssignedDockets(
                selectedDockets.map((d) => ({
                    ...d,
                    attorney_name: d.attorney_name || "",
                    reference_no: d.reference_no || "",
                }))
            );
            setErrors({});
            fetchAttorneys();
        }
    }, [openModal]);

    const fetchAttorneys = async () => {
        try {
            setIsLoading(true);
            const matterIds = selectedDockets.map(docket => docket.id);
            const response = await post("/docgen/matters/parties/search", { matterIds, partyType: "Attorney" }, {});
            const allAttorneys = response.reduce((acc, matter) => {
                acc[matter.id] = matter.matter_parties;
                return acc;
            }, {});
            setAttorneys(allAttorneys);
        }
        catch (err) { }
        finally {
            setIsLoading(false);
        }
    }

    const onRegistrationChange = (index, value) => {
        setAssignedDockets((prev) => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                reference_no: value,
            };
            return updated;
        });
    };

    const handleSave = async () => {
        try {
            setSelectedDockets(assignedDockets);
            closeModal();
        } catch (err) {
        }
    };

    const onAttorneyChange = (index, value, matterId) => {
        const selectedAttorney = (attorneys[matterId] || []).find(
            (a) => a.party.name === value
        );
        setAssignedDockets((prev) => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                matter_id: selectedAttorney,
                attorney_name: selectedAttorney?.party?.name || "",
                reference_no: selectedAttorney?.party?.reference_no || "",
            };
            return updated;
        });
        setErrors((prev) => {
            const updatedErrors = { ...prev };
            delete updatedErrors[selectedDockets[index].id];
            return updatedErrors;
        });
    };

    const handleCopyToAll = (attorneyName, referenceNo, sourceIndex) => {
        const newErrors = {};
        const newAssignedDockets = assignedDockets.map((docket, index) => {
            const matterAttorneys = attorneys[docket.id] || [];
            if (index !== sourceIndex && matterAttorneys?.length > 0) {
                const matchedAttorney = matterAttorneys.find(att => att.party.name === attorneyName);
                if (matchedAttorney) {
                    return {
                        ...docket,
                        matter_id: matchedAttorney,
                        attorney_name: matchedAttorney.party.name,
                        reference_no: referenceNo,
                    };
                } else if (!docket?.attorney_name) {
                    newErrors[docket.id] = "*Not able to fetch the same attorney and registration number";
                    return {
                        ...docket,
                        matter_id: {},
                        attorney_name: "",
                        reference_no: "",
                    }
                }
            }
            return docket;
        });
        setAssignedDockets(newAssignedDockets);
        setErrors(newErrors);
    }
    return (
        <Modal open={openModal} onClose={closeModal} aria-labelledby="assign-attorney">
            <Box sx={{
                position: 'relative',
                top: '50%',
                width: "50vw",
                left: '50%',
                maxHeight: "80vh",
                transform: 'translate(-50%, -50%)',
                bgcolor: 'white',
                borderRadius: "0.3rem",
                p: 4,
                overflowY: "auto",
            }}>
                <Typography id="modal-modal-title" variant="h2" component="h2">
                    Assign Attorney
                </Typography>
                <TableContainer component={Paper} elevation={0} sx={{ boxShadow: "none" }}>
                    <Table sx={{ bgcolor: "white" }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ width: "20%", border: "none" }}>
                                    Docket No.
                                </TableCell>
                                <TableCell sx={{ width: "40%", border: "none" }}>
                                    Attorney Name
                                </TableCell>
                                <TableCell sx={{ width: "40%", border: "none" }}>
                                    Registration Number
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        {isLoading ? (
                            <TableBody>
                                <TableRow>
                                    <TableCell colSpan={3} sx={{ textAlign: "center" }}>
                                        <CircularProgress size={24} />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        ) : (
                            <TableBody>
                                {assignedDockets.map((row, index) => {
                                    const showErrorsMsg = errors?.[row.id];
                                    const showCopyToAll =
                                        row.attorney_name && row.reference_no && assignedDockets?.length > 1;
                                    const showMessage = showErrorsMsg || showCopyToAll;
                                    return (
                                        <>
                                            <TableRow key={index}>
                                                <TableCell sx={{ border: "none", ...(showMessage && { paddingBottom: 0 }) }}>{row.host_file_number}</TableCell>
                                                <TableCell sx={{ border: "none", ...(showMessage && { paddingBottom: 0 }) }}>
                                                    <Select
                                                        value={row.attorney_name || ""}
                                                        onChange={(e) =>
                                                            onAttorneyChange(index, e.target.value, row.id)
                                                        }
                                                        fullWidth
                                                        displayEmpty
                                                        size="small"
                                                    >
                                                        <MenuItem value="">
                                                            <em>Select Attorney</em>
                                                        </MenuItem>
                                                        {(attorneys?.[row.id] || [])?.map((attorney, i) => (
                                                            <MenuItem key={attorney.party?.name} value={attorney?.party?.name}>
                                                                {attorney?.party?.name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </TableCell>
                                                <TableCell sx={{ border: "none", ...(showMessage && { paddingBottom: 0 }) }}>
                                                    <TextField
                                                        value={row.reference_no || ""}
                                                        onChange={(e) =>
                                                            onRegistrationChange(index, e.target.value)
                                                        }
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        placeholder="Registration Number"
                                                        InputProps={{
                                                            sx: {
                                                                "&.Mui-disabled": {
                                                                    cursor: "not-allowed",
                                                                },
                                                                "& .MuiInputBase-input.Mui-disabled": {
                                                                    cursor: "not-allowed",
                                                                },
                                                            },
                                                        }}
                                                        disabled={!row.attorney_name}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                            {showMessage && (
                                                <TableRow sx={{ border: "none" }}>
                                                    <TableCell colSpan={3} sx={{ paddingTop: 0, textAlign: "end", border: "none" }}>
                                                        {showCopyToAll && (
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    mt: 0.5,
                                                                    color: "primary.main",
                                                                    cursor: "pointer",
                                                                    fontSize: "0.8rem",
                                                                    fontWeight: 500,
                                                                    "&:hover": { textDecoration: "underline" },
                                                                }}
                                                                onClick={() =>
                                                                    handleCopyToAll(row.attorney_name, row.reference_no, index)
                                                                }
                                                            >
                                                                Copy to All
                                                            </Typography>
                                                        )}
                                                        {showErrorsMsg && (
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    mt: 0.5,
                                                                    color: "error.main",
                                                                    fontSize: "0.8rem",
                                                                    fontWeight: 500,
                                                                }}
                                                            >
                                                                {showErrorsMsg}
                                                            </Typography>
                                                        )}
                                                    </TableCell>
                                                </TableRow>

                                            )}
                                        </>
                                    );
                                }
                                )}
                            </TableBody>
                        )}
                    </Table>
                </TableContainer>
                <Box mt={3} textAlign="right">
                    <Button onClick={closeModal} sx={{ mr: 2 }}>
                        Cancel
                    </Button>
                    <Button variant="contained" onClick={handleSave}>
                        Save
                    </Button>
                </Box>
            </Box>
        </Modal>
    )
};

export default AssignAttorney;